export default "__VITE_ASSET__12w2P56C__"